export default __webpack_public_path__ + "static/media/lightning.383e1145.svg";